import _ from 'underscore';
import type { RequestVerb } from '../../public-types';
import {
  defaultStubOptions,
} from './instrumentation-utils';
import type {
  ErrorMapper, InstrumentationStubOptions,
} from './instrumentation-utils';

export interface InstrumentationContextOptions {
  pageTrackingId?: string;
  errorMappers?: ErrorMapper[];
  url: string;
  requestId: string;
  httpMethod: RequestVerb;
  stubOptions?: Partial<InstrumentationStubOptions>;
}

export class InstrumentationContext {
  error?: string;
  errorMappers: ErrorMapper[];
  httpMethod: RequestVerb;
  pageTrackingId?: string;
  requestId: string;
  requestResult?: boolean;
  requestStartTime?: number;
  requestTimeTaken?: number;
  responseJSON?: unknown;
  stubOptions: InstrumentationStubOptions;
  url: string;

  constructor(options: InstrumentationContextOptions) {
    this.pageTrackingId = options.pageTrackingId;
    this.errorMappers = options.errorMappers || [];
    this.url = options.url;
    this.requestId = options.requestId;
    this.httpMethod = options.httpMethod;
    this.stubOptions = _.defaults(
      options.stubOptions || {},
      defaultStubOptions,
    ) as InstrumentationStubOptions;
  }
}
